import { render, staticRenderFns } from "./EventModuleComponent.vue?vue&type=template&id=66765c58&scoped=true"
import script from "./EventModuleComponent.vue?vue&type=script&lang=js"
export * from "./EventModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./EventModuleComponent.vue?vue&type=style&index=0&id=66765c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66765c58",
  null
  
)

export default component.exports